import { MenuEntry } from '@src/menu-entry';

export default [
    MenuEntry.create()
        .setRoute('fin_api_transactions_list')
        .setAdditionalRoutes([
            'fin_api_transaction_matching',
        ]),
    MenuEntry.create()
        .setRoute('fin_api_transactions_list_managed_by_accounting')
        .setAdditionalRoutes([
            'fin_api_transaction_matching_managed_by_accounting',
        ]),
];
